export default __webpack_public_path__ + "static/media/reims3.88443b47.jpg";